import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import {
  COMPANY_DETAIL_TABS,
  CompanyDetailScreen,
  type CompanyDetailTab,
} from '@/features/companies/company-detail'

export const companyDetailSearchSchema = z.object({
  tab: z.enum(COMPANY_DETAIL_TABS).optional().default('overview'),
})

export const Route = createFileRoute('/_authenticated/groups/$groupId/companies/$companyId')({
  validateSearch: companyDetailSearchSchema,
  component: CompanyDetailRoute,
})

function CompanyDetailRoute() {
  const { groupId, companyId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  return (
    <CompanyDetailScreen
      groupId={groupId}
      companyId={companyId}
      tab={search.tab}
      onTabChange={(tab: CompanyDetailTab) =>
        // The parent group route also owns a `tab` search key. TanStack merges
        // both route schemas and narrows the value to their intersection even
        // though the child is the active route. Keep this cast at the router
        // boundary; the child schema remains the source of truth at runtime.
        void navigate({
          to: '/groups/$groupId/companies/$companyId',
          params: { groupId, companyId },
          search: (previous) => ({ ...previous, tab }) as unknown as typeof previous,
        })
      }
    />
  )
}
